// Redaction for coordinator-facing tool payloads. Keys off the value
// shape, not the key name, so the short-id form (`shift001`) that
// prompts/phoebe_agent.md emits survives while record UUIDs do not.
// Mirrors sanitize_agent_output_text in phoebe_event_agent/references.py,
// including its opt-out: admin surfaces render identifiers verbatim via
// IdentifierRedactionProvider, as Python does with redact_unresolved_ids.

const UUID_SOURCE =
    '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const URL_SOURCE = 'https?://[^\\s<>\\]|)]+';

// Non-global: `.test()` on a /g regex is stateful across calls.
const UUID_WHOLE_VALUE = new RegExp(`^${UUID_SOURCE}$`);

// URL comes first in the alternation so a UUID inside a link is consumed as
// part of the link and survives — redacting it would break the link.
const URL_OR_UUID = new RegExp(`(${URL_SOURCE})|(\\b${UUID_SOURCE}\\b)`, 'g');

const REDACTED_TEXT = 'the referenced item';

/**
 * True when the value carries nothing but record identifiers — a bare UUID
 * string, or a non-empty array of them. Such entries are dropped from
 * coordinator-facing rendering entirely: unlike a UUID embedded in prose,
 * there is no surrounding sentence left to keep.
 */
export function isUuidOnlyValue(value: unknown): boolean {
    if (typeof value === 'string') {
        return UUID_WHOLE_VALUE.test(value.trim());
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.every(isUuidOnlyValue);
    }
    return false;
}

/** Replace UUIDs inside free text, preserving any URL that contains one. */
export function redactUuidsInText(text: string): string {
    return text.replace(URL_OR_UUID, (match, url: string | undefined) =>
        url === undefined ? REDACTED_TEXT : match,
    );
}
